import { IconSidebarMinimized as IconSidebarToggle, IconHamburgerMenu } from 'components/Icons';
import { useRef, useState } from 'react';
import { cx, css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
import { Link } from 'components/Link';
import { logo, navBarDropdown, navLink__Active, navLink__Radius, btnNoBorder } from 'components/Navbar/Navbar.styles';
import { cssHelpers } from 'styles/utils/core';
import { IconButton } from 'components/Button';
import { EXPANDED_SIDEBAR_WIDTH, EXPANDED_MOBILE_SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH } from 'styles/constants';
import { Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { hideScrollBars } from 'styles/shared';
import { SidebarContent } from './SidebarContent';
import { useSidebarState } from './SidebarContext';
interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {}
interface SidebarContainerProps extends React.HTMLAttributes<HTMLElement> {}
interface SidebarHeaderProps extends React.HTMLAttributes<HTMLElement> {
  handleToggle: () => void;
  isCollapsed?: boolean;
}
const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  handleToggle,
  isCollapsed,
  className,
  ...props
}) => {
  const toggleButtonType = isCollapsed ? 'expand' : 'collapse';
  return <section className={cx(SidebarStyles.header, className)} {...props}>
      <Link aria-label="Go to Clarifai Portal explore homepage" href="/explore" className={cssHelpers.height.content}>
        <div aria-label="Clarifai logo" className={logo} data-testid="clarifai-logo" />
      </Link>
      <div className={cx(SidebarStyles.sidebarButtonWrapper, 'sidebar-btn-wrapper', toggleButtonType)} title={`${toggleButtonType} sidebar`}>
        <button type="button" onClick={handleToggle} data-testid={`sidebar-${toggleButtonType}-btn`} aria-label={`${toggleButtonType} sidebar`}>
          <IconSidebarToggle size={20} strokeWidth={1.5} />
        </button>
      </div>
    </section>;
};
const SidebarContainer: React.FC<SidebarContainerProps> = ({
  className,
  children,
  ...props
}) => {
  return <aside className={cx(SidebarStyles.container, 'sidebar-container', className)} {...props}>
      <div className={cx(SidebarStyles.wrapper, 'sidebar-wrapper', hideScrollBars)}>{children}</div>
    </aside>;
};
export const SidebarV2: React.FC<SidebarProps> = ({
  className,
  ...props
}) => {
  const {
    isCollapsed,
    toggleCollapsed
  } = useSidebarState();

  // Short cooldown to avoid immediate hover re-open right after collapsing
  const [hoverCooldown, setHoverCooldown] = useState(false);
  const cooldownTimerRef = useRef<number | null>(null);
  const handleToggle = () => {
    const wasExpanded = !isCollapsed;
    toggleCollapsed();
    if (wasExpanded) {
      if (cooldownTimerRef.current) clearTimeout(cooldownTimerRef.current);
      setHoverCooldown(true);
      cooldownTimerRef.current = window.setTimeout(() => {
        setHoverCooldown(false);
        cooldownTimerRef.current = null;
      }, 200);
    }
  };
  return <SidebarContainer data-collapsed={isCollapsed} data-hover-cooldown={hoverCooldown} className={cx(SidebarStyles.desktopAddOn, className)} {...props}>
      <SidebarHeader handleToggle={handleToggle} isCollapsed={isCollapsed} />
      <SidebarContent />
    </SidebarContainer>;
};
export const SidebarMobileV2: React.FC<SidebarProps> = ({
  className,
  ...props
}) => {
  const [isDrawerOpened, {
    open: openDrawer,
    close: closeDrawer,
    toggle: toggleDrawer
  }] = useDisclosure();
  return <>
      <Drawer opened={isDrawerOpened} onClose={closeDrawer} withCloseButton={false} padding={0} size={EXPANDED_MOBILE_SIDEBAR_WIDTH} zIndex={1000} styles={{
      body: {
        height: '100%'
      }
    }}>
        <SidebarContainer data-collapsed={!isDrawerOpened} className={cx(SidebarStyles.mobileAddOn, className)} {...props}>
          <SidebarHeader handleToggle={toggleDrawer} isCollapsed={!isDrawerOpened} />
          <SidebarContent />
        </SidebarContainer>
      </Drawer>
      <IconButton aria-label="Mobile sidebar toggle" Icon={IconHamburgerMenu} iconSize={20} size="md" variant="tertiary" className={cx(btnNoBorder, navBarDropdown, navLink__Active, navLink__Radius, SidebarStyles.mobileOnly)} onClick={openDrawer} />
    </>;
};
const SidebarStyles = {
  container: "omponents__SidebarV2__Sidebar_tsx-container-c1ywe6o6",
  wrapper: "omponents__SidebarV2__Sidebar_tsx-wrapper-wup4x7b",
  desktopAddOn: "omponents__SidebarV2__Sidebar_tsx-desktopAddOn-d1wkd8r0",
  mobileAddOn: "omponents__SidebarV2__Sidebar_tsx-mobileAddOn-mor18sk",
  mobileOnly: "omponents__SidebarV2__Sidebar_tsx-mobileOnly-m23i958",
  header: "omponents__SidebarV2__Sidebar_tsx-header-h8nhjs8",
  sidebarButtonWrapper: "omponents__SidebarV2__Sidebar_tsx-sidebarButtonWrapper-s5yu363"
};

require("./Sidebar.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Sidebar.tsx");